import React from 'react'
import { FormattedMessage } from 'react-intl'

export const CLOSE_BUTTON_CAPTION = (
    <FormattedMessage
        id='confirmation.close_button'
        defaultMessage={'Закрыть'}
    />
)


// WEBPACK FOOTER //
// ./components/Confirmation/constants.jsx